// src/pages/applications/DetailRouter.jsx
import { useParams } from "react-router-dom";
import Appointments from "./Appointments";
import Presentation from "./Presentation";
import Testing from "./Testing";
import AdminStarter from "./AdminStarter";
import Management from "./Management";
import LearningApp from "./LearningApp";

const REGISTRY = {
  appointments: Appointments,
  presentation: Presentation,
  testing: Testing,
  adminstarter: AdminStarter,
  management: Management,
  learning: LearningApp
};

export default function ApplicationDetailRouter() {
  const { slug } = useParams();
  const Comp = REGISTRY[slug];
  if (!Comp) {
    return (
      <section className="mx-auto max-w-4xl px-4 py-16 text-center">
        <h1 className="text-2xl font-bold">App not found</h1>
        <p className="mt-2 text-slate-600">Choose an app from the catalog.</p>
      </section>
    );
  }
  return <Comp />;
}
